export enum EDruhAkcie {
    KMEN = 'KMEN',
    PRIOR = 'PRIOR',
    PRIORKUS = 'PRIORKUS',
    KUS = 'KUS',
    JINA = 'JINA'
}
